<template>
    <div>
        <Header @quotes="searchList" @Information="searchInformation" />
        <div v-if="quotes.length > 0" class="container" id="scrolltop">
            <div id="grad" v-if="$route.name == 'home'"></div>
            <h2>Search Results</h2>
            <div class="gsc-result-info" id="resInfo-0">About {{Information.formattedTotalResults}} results ({{Information.formattedSearchTime}} seconds)</div>
            <div class="col-md-12 " v-for="(post, postIndex) in quotes" :key="postIndex">
                <div class="card card-shadow">
                    <div class="card-body">
                        <div class="gs-bidi-start-align gs-visibleUrl gs-visibleUrl-short">
                            <h5 class="card-title">
                                <a class="text-dark" :href="post.link">{{ post.title }}</a>
                            </h5>
                        </div>
                        <div class="gs-bidi-start-align gs-visibleUrl gs-visibleUrl-long">
                            <a class="gs-bidi-start-align gs-visibleUrl gs-visibleUrl-long" :href="post.link">{{ post.link }}</a>
                        </div>
                        <div v-if="post.src" class="gs-image-box gs-web-image-box gs-web-image-box-portrait">
                            <img :src="post.src" />
                        </div>
                        <h5 class="card-title">
                            {{post.snippet}}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="quotes.length == 0" id="scrolltop">
            <div id="grad" v-if="$route.name == 'home'"></div>
            <div class="row mt-spacer">
                <div class="d-none col-lg-3 d-lg-block sidebar" v-if="!menuhide">
                    <Sidebar />
    
                </div>
                <div class="col-lg-9" v-if="!menuhide">
                    <router-view :key="$route.fullPath">
                        <Home />
                    </router-view>
                </div>
    
                <div class="col-md-12" v-if="menuhide">
                    <router-view :key="$route.fullPath">
                        <Home />
                    </router-view>
                </div>
            </div>
            <Subsidiary v-if="this.$router.currentRoute.name == 'home'" />
        </div>
        <Footer />
        <div class="modal fade" id="refreshAppUIModal" tabindex="-1" role="dialog" aria-labelledby="refreshAppUIModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">New content available. Update app?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" v-on:click="refreshApp()">Yes</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
require('./assets/scss/responsive.scss');
require('./assets/css/font-awesome.css');
if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
) {
    require('./assets/scss/app-mobile.scss');
} else {
    require('./assets/scss/app.scss');
}
// require("./assets/js/app.js");
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Sidebar from "./components/sidebar.vue";
import Home from "./views/Home.vue";
import Subsidiary from "./components/subsidiaries.vue";
import Cms from "@/services/Cms";
import GenericMixin from "@/mixins/GenericMixin";
export default {
    name: "home-page",
    mixins: [GenericMixin],
    metaInfo() {
        let telephone = this.internationalTelNo || "";
        return {
            title: 'Welcome To My Healthy Staff',
            htmlAttrs: {
                vuemetahtml: 'vuemeta-htmlmain'
            },
            headAttrs: {
                vuemeta: 'vuemeta-header'
            },
            meta: [
                { vmid: 'description', name: 'description', content: 'Welcome To My Healthy Staff' },
                { vmid: 'keywords', name: 'keywords', content: 'Welcome To My Healthy Staff' }
            ],
            script: [{
                vmid: 'jsonld-schema', 
                type: 'application/ld+json',
                json: {
                    "@context": "http://schema.org",
                    "@type": "Organization",
                    "name": "My Healthy Staff",
                    "url": "https://www.myhealthystaff.com/",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Building 5, 3rd Floor",
                        "addressLocality": "566 Chiswick High Road, Chiswick",
                        "addressRegion": "London",
                        "postalCode": "W4 5YF",
                        "addressCountry": "United Kingdom"
                    },
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "contactType": "customer support",
                        "telephone": telephone,
                        "email": "enquiries@hs-group.com"
                    }
                }
            }]
        }
    },
    components: {
        Header,
        Footer,
        Home,
        Sidebar,
        Subsidiary
    },
    data() {
        return {
            refreshing: false,
            registration: null,
            menuhide: false,
            activeTab: "",
            quotes: [],
            Information: []
        };
    },
    created() {
        // Listen for swUpdated event and display refresh snackbar as required.
        document.addEventListener('swUpdated', this.showRefreshUI, { once: true });

        // Refresh all open app tabs when a new service worker is installed.
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (this.refreshing) return;
                this.refreshing = true;
                window.location.reload();
            });
        }
    },
    beforeMount(){
        let fancyBoxScript = document.createElement("script");
        fancyBoxScript.setAttribute(
            "src",
            "https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.7/dist/jquery.fancybox.min.js"
        );
        document.head.appendChild(fancyBoxScript);

        Cms.getContactInfo()
        .then(resp => this.$store.commit('storeContactInfo',  resp.data.data))
        .catch(error =>  console.error("Failed to get contact info.") );
    },
    mounted() {
        if(window.location.host == 'www.myhealthystaff.com') this.renderGTag();

        this.menuhide = false;
        this.activeTab = null;
        if (this.$router.currentRoute.name == 'home') {
            document.body.className = 'linear';
        } else {
            document.body.classList.remove('linear');
        }
        if (this.$store.state.auth) {
            if (this.$router.currentRoute.meta.requiresAuth) {
                this.activeTab = this.$router.currentRoute.name;
            }
        }
        if (this.$router.currentRoute.meta.requiresAuth) {
            if (
                this.$router.currentRoute.name == "payment" ||
                this.$router.currentRoute.name == "make-payment" ||
                this.$router.currentRoute.name == "iFrameForPayment" ||
                this.$router.currentRoute.name == "confirm" ||
                this.$router.currentRoute.name == "invoice" ||
                this.$router.currentRoute.name == "delivery" ||
                this.$router.currentRoute.name == "paypal-confirm" ||
                this.$router.currentRoute.name == "subscribe-basket" ||
                this.$router.currentRoute.name == "change-lms-invoice" ||
                this.$router.currentRoute.name == "checkout-lms" ||
                this.$router.currentRoute.name == "subscription-make-payment" ||
                this.$router.currentRoute.name == "license-processing-payment" ||
                this.$router.currentRoute.name == "thankyou-subscriber"
            ) {
                this.menuhide = true;
            }
        }

        if (this.$router.currentRoute.meta.requireVisitor) {
            if (
                this.$router.currentRoute.name == "basket" ||
                this.$router.currentRoute.name == "login" ||
                this.$router.currentRoute.name == "forgot" ||
                this.$router.currentRoute.name == "quick guides more" ||
                this.$router.currentRoute.name == "forgot password" ||
                this.$router.currentRoute.name == "login_download" ||
                this.$router.currentRoute.name == "order-form"
            ) {
                this.menuhide = true;
            }

            if (
                this.$router.currentRoute.name == "cms" ||
                this.$router.currentRoute.name == "help" ||
                this.$router.currentRoute.name == "contact" ||
                this.$router.currentRoute.name == "quick guides" ||
                this.$router.currentRoute.name == "help/downloads" ||
                this.$router.currentRoute.name == "help/about-us" ||
                this.$router.currentRoute.name == "help/ways-to-pay" ||
                this.$router.currentRoute.name == "help/privacy-policy" ||
                this.$router.currentRoute.name == "help/terms-conditions" ||
                this.$router.currentRoute.name == "help/technical-faq" ||
                this.$router.currentRoute.name == "help/accessibility-statement" ||
                this.$router.currentRoute.name == "help/site-map" ||
                this.$router.currentRoute.name == "help/request-a-catalogue"
            ) {
                this.menuhide = false;
            }
        }
    },
    watch: {
        $route(to, from) {
            if (this.$router.currentRoute.name) {
                this.quotes = '';
            }
            if (this.$router.currentRoute.name == 'home') {
                document.body.className = 'linear';
            } else {
                document.body.classList.remove('linear');
            }

            this.menuhide = false;
            this.activeTab = null;
            if (this.$store.state.auth) {
                if (this.$router.currentRoute.meta.requiresAuth) {
                    this.activeTab = this.$router.currentRoute.name;
                }
            }
            if (this.$router.currentRoute.meta.requiresAuth) {
                if (
                    this.$router.currentRoute.name == "payment" ||
                    this.$router.currentRoute.name == "make-payment" ||
                    this.$router.currentRoute.name == "iFrameForPayment" ||
                    this.$router.currentRoute.name == "confirm" ||
                    this.$router.currentRoute.name == "invoice" ||
                    this.$router.currentRoute.name == "delivery" ||
                    this.$router.currentRoute.name == "paypal-confirm" ||
                    this.$router.currentRoute.name == "subscribe-basket" ||
                    this.$router.currentRoute.name == "change-lms-invoice" ||
                    this.$router.currentRoute.name == "checkout-lms" ||
                    this.$router.currentRoute.name == "subscription-make-payment" ||
                    this.$router.currentRoute.name == "license-processing-payment" ||
                    this.$router.currentRoute.name == "thankyou-subscriber"
                ) {
                    this.menuhide = true;
                }
            }
            if (this.$router.currentRoute.meta.requireVisitor) {
                if (
                    this.$router.currentRoute.name == "basket" ||
                    this.$router.currentRoute.name == "login" ||
                    this.$router.currentRoute.name == "forgot" ||
                    this.$router.currentRoute.name == "quick guides more" ||
                    this.$router.currentRoute.name == "forgot password" ||
                    this.$router.currentRoute.name == "bookingform" ||
                    this.$router.currentRoute.name == "booking-confirm" ||
                    this.$router.currentRoute.name == "login_download" ||
                    this.$router.currentRoute.name == "order-form"
                ) {
                    this.menuhide = true;
                }

                if (
                    this.$router.currentRoute.name == "cms" ||
                    this.$router.currentRoute.name == "help" ||
                    this.$router.currentRoute.name == "contact" ||
                    this.$router.currentRoute.name == "quick guides" ||
                    this.$router.currentRoute.name == "help/downloads" ||
                    this.$router.currentRoute.name == "help/about-us" ||
                    this.$router.currentRoute.name == "help/ways-to-pay" ||
                    this.$router.currentRoute.name == "help/privacy-policy" ||
                    this.$router.currentRoute.name == "help/terms-conditions" ||
                    this.$router.currentRoute.name == "help/technical-faq" ||
                    this.$router.currentRoute.name == "help/accessibility-statement" ||
                    this.$router.currentRoute.name == "help/site-map" ||
                    this.$router.currentRoute.name == "help/request-a-catalogue"
                ) {
                    this.menuhide = false;
                }
            }
        }
    },
    methods: {
        showRefreshUI(e) {
            // The new service worker is installed, but not yet active.
            // Store the ServiceWorkerRegistration instance for later use.
            this.registration = e.detail;
            $('#refreshAppUIModal').modal('show');
        },
        refreshApp() {
            this.registration.waiting.postMessage('skipWaiting');
        },
        searchList(searchLists) {

            this.quotes = searchLists;

        },
        searchInformation(Informations) {
            this.Information = Informations;

        },
        renderGTag(){
            const tagManager = document.createElement('script');
            const gTagScript = document.createElement('script');

            tagManager.src = "https://www.googletagmanager.com/gtag/js?id=UA-219872-1";
            gTagScript.text = `window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', 'UA-219872-1');
                                gtag('config', 'AW-1071683596');`;
            
            document.body.appendChild(tagManager);
            document.body.appendChild(gTagScript);
        }
    }
};
</script>


<style lang="scss">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
    a {
        font-weight: bold;
        color: #2c3e50;
        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

.bg-gradient {
    background: -webkit-gradient(linear, left top, left bottom, from(#e4e4e4), color-stop(15%, #e4e4e4), to(#fff));
    background: linear-gradient(180deg, #e4e4e4, #e4e4e4 15%, #fff);
    width: 100%;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
}

#scrolltop {
    overflow: hidden;
}

.gs-web-image-box,
.gs-promotion-image-box {
    float: left;
    padding: 2px 8px 2px 0px;
    margin-right: 0px;
    margin-left: 0px;
    text-align: center;
    width: 62px;
}

a.gs-bidi-start-align.gs-visibleUrl.gs-visibleUrl-long {
    color: #008000;
}

.gsc-result-info {
    text-align: left;
    color: #676767;
    font-size: 13px;
    padding-left: 8px;
    margin: 10px 0 10px 0;
}
</style>

